// Token utility functions for access token management

// Get access token from localStorage
export const getAccessToken = () => {
    return localStorage.getItem("token");
};

// Set access token in localStorage
export const setAccessToken = (token) => {
    if (token) {
        localStorage.setItem("token", token);
    }
};

// Remove access token from localStorage
export const removeAccessToken = () => {
    localStorage.removeItem("token");
};
